"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconCross', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M9.51664 7.92508L11.6959 5.75574C11.9911 5.4643 12.0809 5.02455 11.9233 4.64154C11.7658 4.25853 11.3921 4.00767 10.9763 4.00593C10.721 4.01744 10.4791 4.12324 10.2979 4.30268L8.06723 6.47203L5.88798 4.30268C5.69496 4.10896 5.43222 4 5.15813 4C4.88404 4 4.6213 4.10896 4.42829 4.30268C4.23369 4.49482 4.12422 4.75637 4.12422 5.02921C4.12422 5.30205 4.23369 5.5636 4.42829 5.75574L6.60754 7.92508L4.42829 10.1456C4.0931 10.3853 3.9344 10.8013 4.02528 11.202C4.11616 11.6028 4.43899 11.9105 4.84511 11.9836C5.25123 12.0567 5.66189 11.8809 5.88798 11.5372L8.06723 9.3679L10.2979 11.5372C10.4902 11.7325 10.753 11.8431 11.0277 11.8442C11.2989 11.8404 11.5575 11.73 11.7473 11.5372C12.0988 11.1315 12.0764 10.5245 11.6959 10.1456L9.51664 7.92508Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M11.4143 10.0002L16.7072 4.70725C17.0982 4.31625 17.0982 3.68425 16.7072 3.29325C16.3162 2.90225 15.6843 2.90225 15.2933 3.29325L10.0002 8.58625L4.70725 3.29325C4.31625 2.90225 3.68425 2.90225 3.29325 3.29325C2.90225 3.68425 2.90225 4.31625 3.29325 4.70725L8.58625 10.0002L3.29325 15.2933C2.90225 15.6843 2.90225 16.3162 3.29325 16.7072C3.48825 16.9022 3.74425 17.0002 4.00025 17.0002C4.25625 17.0002 4.51225 16.9022 4.70725 16.7072L10.0002 11.4143L15.2933 16.7072C15.4883 16.9022 15.7442 17.0002 16.0002 17.0002C16.2562 17.0002 16.5122 16.9022 16.7072 16.7072C17.0982 16.3162 17.0982 15.6843 16.7072 15.2933L11.4143 10.0002Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M13.6971 12.0003L20.0487 5.6487C20.5179 5.1795 20.5179 4.4211 20.0487 3.9519C19.5795 3.4827 18.8211 3.4827 18.3519 3.9519L12.0003 10.3035L5.64868 3.9519C5.17948 3.4827 4.42108 3.4827 3.95188 3.9519C3.48268 4.4211 3.48268 5.1795 3.95188 5.6487L10.3035 12.0003L3.95188 18.3519C3.48268 18.8211 3.48268 19.5795 3.95188 20.0487C4.18588 20.2827 4.49308 20.4003 4.80028 20.4003C5.10748 20.4003 5.41468 20.2827 5.64868 20.0487L12.0003 13.6971L18.3519 20.0487C18.5859 20.2827 18.8931 20.4003 19.2003 20.4003C19.5075 20.4003 19.8147 20.2827 20.0487 20.0487C20.5179 19.5795 20.5179 18.8211 20.0487 18.3519L13.6971 12.0003Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M18.2628 16.0004L26.7316 7.5316C27.3572 6.906 27.3572 5.8948 26.7316 5.2692C26.106 4.6436 25.0948 4.6436 24.4692 5.2692L16.0004 13.738L7.53159 5.2692C6.90599 4.6436 5.89479 4.6436 5.26919 5.2692C4.64359 5.8948 4.64359 6.906 5.26919 7.5316L13.738 16.0004L5.26919 24.4692C4.64359 25.0948 4.64359 26.106 5.26919 26.7316C5.58119 27.0436 5.99079 27.2004 6.40039 27.2004C6.80999 27.2004 7.21959 27.0436 7.53159 26.7316L16.0004 18.2628L24.4692 26.7316C24.7812 27.0436 25.1908 27.2004 25.6004 27.2004C26.01 27.2004 26.4196 27.0436 26.7316 26.7316C27.3572 26.106 27.3572 25.0948 26.7316 24.4692L18.2628 16.0004Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;